import type {BrandLogo} from '@Components/mystuff-brands/brand-kits.types';
import {useAppSelector} from '@/hooks';

export const useBrandLogosMap = (): Record<string, BrandLogo> => {
  return useAppSelector(({brands}) => {
    return brands.logos as Record<string, BrandLogo>;
  });
};
